<template>
  <div v-if="loadPage">
    <div class="container" v-if="!loading">
      <div class="primarylists list-mobile" v-if="mobile">
        <div class="titles clear" id="explore">
          <button class="btn-tast btn-next-1" @click="back()">
            <span>{{ $t("common.returnButton") }}</span>
          </button>
          <div class="title l">{{ dataDetails.courseName }}</div>
        </div>
      </div>
      <div class="flex-container flex-teacher">
        <div class="media-teacher">
          <div class="box-media">
            <template v-if="teacher.coverImage">
              <img :src="teacher.coverImage" alt="" @error="setAltTeacher" />
            </template>
            <template v-else>
              <img
                v-if="teacher.gender"
                src="../../../static/images/SA-ava-nu.png"
                alt=""
              />
              <img v-else src="../../../static/images/profile.jpg" alt="" />
            </template>
          </div>
          <div class="box-text">
            <p class="name-teacher">{{ teacher.userName }}</p>
            <p class="icon-student">👨‍🎓</p>
            <p class="number-student">
              {{ dataDetails.totalStudent }} {{ $t("new.title141") }}
            </p>
          </div>
          <div class="valuate-teacher">
            <span class="number-stars">{{ dataDetails.courseEvaluate }}</span>
            <!-- Sao đánh giá -->
            <span class="startIndex">
              <div
                class="Stars"
                :style="'--rating:' + dataDetails.courseEvaluate"
              ></div>
            </span>
          </div>
        </div>
        <div class="detail_course">
          <h3>
            {{ dataDetails.courseName }}
          </h3>
          <div>
            <h4>&#x261B; {{ $t("new.title212") }}:</h4>
            <p v-html="dataDetails.courseSynopsis"></p>
          </div>
          <div>
            <h4>&#x261B; {{ $t("new.title213") }}:</h4>
            <p v-html="teacher.synopsis"></p>
          </div>
        </div>
      </div>
      <div class="flex-container">
        <div class="media-course">
          <div class="box-media-course">
            <template
              v-if="
                dataDetails.linkYoutube != null && dataDetails.linkYoutube != ''
              "
            >
              <iframe
                :class="{ image_youtube_moblie: mobile }"
                width="100%"
                height="400px"
                :src="dataDetails.linkYoutube"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              >
              </iframe>
            </template>
            <template v-else>
              <template
                v-if="
                  dataDetails.courseCover == null ||
                    dataDetails.courseCover == ''
                "
              >
                <img src="../../../static/images/temppic.jpg" alt="/" />
              </template>
              <template v-else>
                <template v-if="dataDetails.courseCover.match(regExp)">
                  <iframe
                    :class="{ image_youtube_moblie: mobile }"
                    width="100%"
                    height="400px"
                    :src="dataDetails.courseCover"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  >
                  </iframe>
                </template>
                <template v-else>
                  <img
                    :src="dataDetails.courseCover"
                    alt="/"
                    @error="setAltCourse"
                  />
                </template>
              </template>
            </template>
            <div class="flash-sale">
              <span v-if="dataDetails.offSelf != 0"
                >( {{ dataDetails.offSelf }}% OFF )</span
              >
            </div>
          </div>
        </div>
        <div class="detail_info-course">
          <div class="box-info">
            <span>
              <!-- <template v-if="checkGeneralEnvironmentIndex==4&&checkGeneralEnvironmentDongDuIndex"> -->
              <button
                id="cart"
                href=""
                v-on:click="added(dataDetails, listId, catalogId)"
              >
                {{ $t("new.title207") }}
              </button>
              <!-- </template>
                            <template v-else>
                                <button id="cart" href="" v-on:click="added(dataDetails.courseId,dataDetails.courseName,dataDetails.coursePrice,dataDetails.courseCover,dataDetails.courseEstimatedStudyTime,dataDetails.courseCurriculumTotal,dataDetails.coursePriceDiscount,dataDetails.offSelf,listId,catalogId)">{{ $t("new.title142") }}</button>
                            </template> -->
              <button
                id="sub"
                href=""
                @click="clickNextPageSubsribe(dataDetails, listId)"
              >
                {{ $t("new.title143") }}
              </button>
              <button id="cancel_details" v-if="!mobile" @click="back()">
                {{ $t("common.returnButton") }}
              </button>
            </span>
            <div>
              <div class="price" v-if="mobile">
                <div
                  v-if="
                    dataDetails.offSelf == 100 || dataDetails.coursePrice == 0
                  "
                >
                  <span class="free-course">{{ $t("new.title215") }}</span>
                </div>
                <div v-else-if="dataDetails.coursePrice < 0">
                  <span class="free-course"></span>
                </div>
                <div v-else>
                  <h3>{{ $t("new.title144") }}:</h3>
                  <div class="style-1">
                    <del>
                      <span v-if="dataDetails.offSelf != 0" class="amount"
                        ><span v-if="beforCurren">{{ $t("new.title121") }}</span
                        >{{ dataDetails.priceBeforOff
                        }}<span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></span
                      >
                    </del>
                    <ins>
                      <span v-if="dataDetails.offSelf != 0" class="amount"
                        ><span v-if="beforCurren">{{ $t("new.title121") }}</span
                        >{{ dataDetails.priceAfterOff }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></span
                      >
                      <span v-else class="amount"
                        ><span v-if="beforCurren">{{ $t("new.title121") }}</span
                        >{{
                          dataDetails.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></span
                      >
                    </ins>
                  </div>
                </div>
              </div>
            </div>
            <div class="info">
              <div v-if="!mobile">
                <div
                  v-if="
                    dataDetails.offSelf == 100 || dataDetails.coursePrice == 0
                  "
                >
                  <span class="free-course">{{ $t("new.title215") }}</span>
                </div>
                <div v-else-if="dataDetails.coursePrice < 0">
                  <span class="free-course"></span>
                </div>
                <div v-else>
                  <p>
                    {{ $t("new.title144") }}:
                    <span style="display: -webkit-inline-box;">
                      <del>
                        <span v-if="dataDetails.offSelf != 0" class="amount"
                          ><span v-if="beforCurren">{{
                            $t("new.title121")
                          }}</span>
                          {{ dataDetails.priceBeforOff }}
                          <span v-if="afterCurren">{{
                            $t("new.title121")
                          }}</span></span
                        >
                      </del>
                      <ins>
                        <span v-if="dataDetails.offSelf != 0" class="amount"
                          ><span v-if="beforCurren">{{
                            $t("new.title121")
                          }}</span>
                          {{ dataDetails.priceAfterOff }}
                          <span v-if="afterCurren">{{
                            $t("new.title121")
                          }}</span></span
                        >
                        <span v-else class="amount"
                          ><span v-if="beforCurren">{{
                            $t("new.title121")
                          }}</span>
                          {{
                            dataDetails.coursePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren">{{
                            $t("new.title121")
                          }}</span></span
                        >
                      </ins>
                    </span>
                  </p>
                </div>
              </div>
              <p>
                {{ $t("new.title145") }}:
                <b
                  >{{ dataDetails.courseEstimatedStudyTime }}
                  {{ $t("new.title146") }}</b
                >
              </p>
              <p>
                {{ $t("new.title147") }}:
                <b
                  >{{ dataDetails.courseCurriculumTotal }}
                  {{ $t("new.title154") }}</b
                >
              </p>
              <p v-if="dataDetails.offSelf != 0">
                {{ $t("new.title148") }}:
                <b>{{ dataDetails.coursePriceDiscountTime }}</b>
              </p>
              <p>
                {{ $t("new.title149") }}:
                <b>{{ dataDetails.totalStudent }} {{ $t("new.title141") }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content-course"
        v-if="this.dataDetails.courseContentDetails != ''"
      >
        <div class="header-tab" v-on:click="toggle('content')">
          <h3>
            {{ $t("new.title150")
            }}<!--  -->
            <span><p>&#128317;</p></span>
          </h3>
        </div>
        <div class="content">
          <p v-if="content" v-html="dataDetails.courseContentDetails"></p>
        </div>
      </div>
      <div
        class="catalog-course"
        v-if="this.dataDetails.courseListCurrilum != ''"
      >
        <div class="header-tab" v-on:click="toggle('catalog')">
          <h3>
            {{ $t("new.title151")
            }}<!--  -->
            <span><p>&#128317;</p></span>
          </h3>
        </div>
        <div class="content">
          <p v-if="catalog" v-html="dataDetails.courseListCurrilum"></p>
        </div>
      </div>
    </div>
    <div class="shopping-cart">
      <p
        class="button-icon"
        id="shopping-cart"
        v-if="cart.length > 0"
        v-on:click="OpenModal()"
      >
        <img src="../../../static/images/Ellipse 5.png" alt="" /><b
          class="total-item-cart"
          >{{ cart.length }}</b
        >
      </p>
      <!-- The Modal -->
      <div id="myModal-Cart" class="modal">
        <!-- Modal content -->
        <div class="modal-content" :class="[{ mb: mobile }]">
          <div class="top-close" v-if="mobile">
            <span v-on:click="CloseModal()" class="close">{{
              $t("new.title208")
            }}</span>
          </div>
          <span v-if="!mobile" v-on:click="CloseModal()" class="close">{{
            $t("new.title208")
          }}</span>
          <div class="cart-content">
            <div v-if="cart.length == 0">
              <img
                class="empty-cart"
                src="../../../static/images/GHtrong2-xanh.png"
                width="250"
                alt="/"
              />
              <!-- <h3 style="text-align:center">{{ $t("new.title152") }} </h3> -->
            </div>
            <table class="cart-table" style="width:100%;">
              <tr
                id="item-course"
                v-for="(carts, index) in cart"
                :key="carts.courseId"
              >
                <td
                  class="item-image"
                  :class="{ cart_moblie: mobile }"
                  style="width:35%;text-align: -webkit-center;"
                >
                  <template
                    v-if="carts.courseCover == null || carts.courseCover == ''"
                  >
                    <img src="../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="carts.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="carts.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img
                        :src="carts.courseCover"
                        alt="/"
                        @error="setAltCourse"
                      />
                    </template>
                  </template>
                </td>
                <td
                  class="item-title"
                  :class="{ cart_moblie: mobile }"
                  style="width:55%"
                >
                  <h3
                    style="color:#0071c5;line-height:20px;word-break: break-word;"
                  >
                    {{ carts.courseName }}
                  </h3>
                  <div style="float:left">
                    <p>{{ $t("new.title145") }}:</p>
                    <p>{{ $t("new.title147") }}:</p>
                    <p v-if="carts.coursePrice >= 0">{{ $t("new.title153") }}:</p>
                  </div>
                  <div style="float:left;padding-left:10px;font-weight:600">
                    <p>{{ carts.timestudy }} {{ $t("new.title146") }}</p>
                    <p>{{ carts.totalless }} {{ $t("new.title154") }}</p>
                      <tempalte v-if="carts.coursePrice>=0">
                        <p v-if="carts.offSelf != 0" class="item-price-cart">
                           <span v-if="beforCurren">{{ $t("new.title121") }}</span
                           >{{
                              (carts.coursePrice - carts.coursePriceDiscount)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                           }}
                           <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        </p>
                        <p v-else class="item-price-cart">
                           <span v-if="beforCurren">{{ $t("new.title121") }}</span
                           >{{
                              carts.coursePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                           }}
                           <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        </p>
                    </tempalte>
                  </div>
                </td>
                <td
                  class="item-close"
                  title="bỏ khóa học"
                  style="width:10%"
                  v-on:click="
                    CloseItemCourse(
                      index,
                      carts.coursePrice - carts.coursePriceDiscount
                    )
                  "
                >
                  &#10008;
                </td>
              </tr>
              <tr v-if="cart.length > 0">
                <td colspan="3" class="item-total">
                  <p v-if="reduce>=0">
                    {{ $t("new.title155") }} :
                    <span
                      ><b
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          reduce
                            .toString().replace('.00', '')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></b
                      ></span
                    >
                  </p>
                </td>
              </tr>
            </table>

            <button
              v-if="cart.length > 0"
              class="submit"
              @click="NextPageSubsribeCart()"
            >
              {{ $t("new.title143") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <commentSeflCourse :data="dataDetails"></commentSeflCourse>
    <relatedCourse v-on:loadPageClick="loadPageClick($event)"></relatedCourse>
    <!-- Dialog erorr select multiple course -->
    <div id="myModal-errorCart" class="modal">
      <div class="modal-content  modal-error">
        <span v-on:click="CloseModalerorr()" class="close">&times;</span>
        <p class="messa-error">{{ $t("new.title195") }}</p>
        <span>
          <button class="button-error-continute" @click="nextBackCourse()">
            {{ $t("new.title196") }}
          </button>
        </span>
      </div>
    </div>
    <loading class="loading--lesson" :showLoading="loading" />
  </div>
</template>
<script>
import commentSeflCourse from "@/components/defineSelfCourse/detailsSelfCourse/comment";
import relatedCourse from "@/components/defineSelfCourse/detailsSelfCourse/relatedCourse";
import loading from "@/components/loading/loading";
export default {
  name: "TeacherInfo",
  props: {
    msg: String
  },
  data() {
    return {
      userId:null,
      email:null,
      isLogin: true,
      content: true,
      catalog: true,
      related: true,
      dataDetails: {},
      cartadd: {},
      cart: [],
      badge: 0,
      reduce: 0,
      outlineInfo: eval("(" + this.$route.query.outlineInfo + ")"),
      teacher: {},
      listId: [],
      catalogId: null,
      level1: "",
      level2: "text-indent:20px",
      level3: "text-indent:40px",
      level4: "text-indent:60px",
      level5: "text-indent:80px",
      loadPage: true,
      checkGeneralEnvironmentIndex: 0,
      checkGeneralEnvironmentDongDuIndex: true,
      afterCurren: false,
      beforCurren: false,
      regExp: /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
      templateYoutubeSrc: "https://www.youtube.com/embed/",
      loading: true
    };
  },
  components: {
    commentSeflCourse,
    relatedCourse,
    loading
  },
  mounted() {
    this.checkGeneralEnvironmentIndex = this.checkGeneralEnvironment();
    this.checkGeneralEnvironmentDongDuIndex = this.checkGeneralEnvironmentDongDu();
    this.listId = JSON.parse(JSON.stringify(this.outlineInfo.listId));
    this.catalogId = this.outlineInfo.catalogId;
    this.courseListCurrilum();
    this.checkCurren();
    //check user
    this.$autoLogin().then(
      () => {
        this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
        this.email = window.sessionStorage.getItem("email");
        this.isLogin = true;
      },
      () => {
        this.isLogin = false;
        this.userId = null;
      }
    );
  },
  async created() {
    this.viewCart();
    await this.init();
    // Gắn dữ liệu mục lục
    this.dataDetails.courseListCurrilum = this.dataDetails.courseListCurrilum
      .replace(/\[Level1.*?\]/g, `<p style="${this.level1}"><b>&#10070;</b>`)
      .replace(/\[Level2.*?\]/g, `<p style="${this.level2}"><b>&#10065;</b>`)
      .replace(/\[Level3.*?\]/g, `<p style="${this.level3}"><b>&#10148;</b>`)
      .replace(/\[Level4.*?\]/g, `<p style="${this.level4}"><b>&#9654;</b>`)
      .replace(/\[Level5.*?\]/g, `<p style="${this.level5}"><b>&#9655;</b>`);
    // document.getElementById("content-catalog").innerHTML = this.dataDetails.courseListCurrilum;
    // fomat text content
    this.dataDetails.courseContentDetails = this.dataDetails.courseContentDetails
      .replace(/\r\n/g, "<br>")
      .replace(/[ ]/g, " ");
    // document.getElementById("content-detail").innerHTML = this.dataDetails.courseContentDetails;
    // fomat text content
    this.dataDetails.courseSynopsis = this.dataDetails.courseSynopsis
      .replace(/\r\n/g, "<br>")
      .replace(/[ ]/g, " ");
    this.teacher.synopsis = this.teacher.synopsis
      .replace(/\r\n/g, "<br>")
      .replace(/[ ]/g, " ");
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    }
  },
  methods: {
    async init() {
      this.dataDetails = await this.getDetailsByCourseId();
      this.teacher = this.dataDetails.teacher;
      this.dataDetails["priceAfterOff"] = (
        this.dataDetails.coursePrice - this.dataDetails.coursePriceDiscount
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.dataDetails[
        "priceBeforOff"
      ] = this.dataDetails.coursePrice
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (this.dataDetails.courseCover.match(this.regExp)) {
        let temp = this.dataDetails.courseCover.split("https://youtu.be/");
        this.dataDetails.courseCover = this.templateYoutubeSrc + temp[1];
      }
      if (this.dataDetails.linkYoutube) {
        if (this.dataDetails.linkYoutube.match(this.regExp)) {
          let temp = this.dataDetails.linkYoutube.split("https://youtu.be/");
          this.dataDetails.linkYoutube = this.templateYoutubeSrc + temp[1];
        }
      }
      this.dataDetails.courseContentDetails = this.dataDetails.courseContentDetails
        .replace(/\r\n/g, "<br>")
        .replace(/[ ]/g, " ");
      this.dataDetails.courseSynopsis = this.dataDetails.courseSynopsis
        .replace(/\r\n/g, "<br>")
        .replace(/[ ]/g, " ");
      this.teacher.synopsis = this.teacher.synopsis
        .replace(/\r\n/g, "<br>")
        .replace(/[ ]/g, " ");
      this.dataDetails.courseListCurrilum = this.dataDetails.courseListCurrilum
        .replace(/\[Level1.*?\]/g, `<p style="${this.level1}"><b>&#10070;</b>`)
        .replace(/\[Level2.*?\]/g, `<p style="${this.level2}"><b>&#10065;</b>`)
        .replace(/\[Level3.*?\]/g, `<p style="${this.level3}"><b>&#10148;</b>`)
        .replace(/\[Level4.*?\]/g, `<p style="${this.level4}"><b>&#9654;</b>`)
        .replace(/\[Level5.*?\]/g, `<p style="${this.level5}"><b>&#9655;</b>`);
      this.loading = false;
    },
    getDetailsByCourseId() {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getDetailsByIdCourse", {
            courseId: this.outlineInfo.courseId,
            languageType: this.$lang()
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },
    courseListCurrilum() {
      //  this.dataDetails.courseListCurrilum = this.dataDetails.courseListCurrilum.replace(/Level1/g, "<h4></h4><span style='font-size:20px'>").replace(/Level2/g, "<li style='list-style:none;line-height:30px;font-weight:400;text-indent:10px;font-size:16px'><span>&#9654;</span>").replace(/Level3/g, "<li style='list-style:none;line-height:30px;font-weight:400;text-indent:20px;font-size:16px'><span>&#9655</span>");
    },
    setAltTeacher(event) {
      event.target.src = "../../../static/images/SA-ava-nu.png";
    },
    setAltCourse(event) {
      event.target.src = "../../../static/images/temppic.jpg";
    },
    toggle(value) {
      if (value == "content") {
        this.content = !this.content;
      } else if (value == "related") {
        this.related = !this.related;
      } else {
        this.catalog = !this.catalog;
      }
    },
    //Đóng mở giỏ hàng
    OpenModal() {
      document.getElementById("myModal-Cart").style.display = "block";
    },
    CloseModal() {
      document.getElementById("myModal-Cart").style.display = "none";
    },
    //Đóng mở dialog thêm nhiều khóa học cùng loại
    OpenModalerorr() {
      document.getElementById("myModal-errorCart").style.display = "block";
    },
    CloseModalerorr() {
      document.getElementById("myModal-errorCart").style.display = "none";
    },
    //Đóng từng item khóa học
    CloseItemCourse(id, price) {
      this.cart.splice(id, 1);
      if (this.reduce > 0 && price >= 0 ) {
        this.reduce -= price;
      }
      this.saveCats();
    },
    // Hiển thị dialog erorr khi thêm nhiều lần khóa học

    async added(item, listId, catalogId) {
      if (this.isLogin) {
        let courseIdByApplyInfo = this.outlineInfo.courseId;
        let companyId = await this.getCompanyIdByIdOfApplyCourse(courseIdByApplyInfo);
        let userQuantityAfterLogin = await this.checkUserExistenceAfterLogin(this.email,companyId,courseIdByApplyInfo);
        if (userQuantityAfterLogin != 0) {
          this.$message({
            type: "warning",
            message: window.vm.$i18n.t("new.title244"),
            customClass: "custom-warning-message"
          });
          return;
        }
      }
      // cartadd is here to get all things that click or chosen by user
      const checkUsername = obj => obj.courseId === item.courseId;
      if (this.cart.some(checkUsername) == false) {
        this.cartadd.courseId = item.courseId;
        this.cartadd.courseName = item.courseName;
        this.cartadd.coursePrice = item.coursePrice;
        this.cartadd.courseCover = item.courseCover;
        this.cartadd.timestudy = item.courseEstimatedStudyTime;
        this.cartadd.totalless = item.courseCurriculumTotal;
        this.cartadd.qty = 1;
        this.cartadd.coursePriceDiscount = item.coursePriceDiscount;
        this.cartadd.offSelf = item.offSelf;
        this.cartadd.listId = listId;
        this.cartadd.catalogId = catalogId;
        this.cartadd.courseEvaluate = this.dataDetails.courseEvaluate;
        this.cartadd.courseBankInfo = item.courseBankInfo;
        this.cart.push(this.cartadd);
        this.saveCats(); // this function most important to save all inform of products
        // if(this.reduce>=0){
        //     this.reduce += this.cartadd.price;
        // }
        this.OpenModal();
      } else {
        // alert(this.$t("new.title130"));
        this.OpenModalerorr();
      }
    },
    NextPageSubsribeCart() {
      this.$router.push({
        path: "/home/subscribeSelfCourse",
        query: {
          outlineInfo: JSON.stringify(this.outlineInfo)
        }
      });
    },
    //Back page Course Self
    nextBackCourse() {
      this.$router.push({
        path: "/home/index",
        query: {}
      });
    },
    async clickNextPageSubsribe(item, listId) {
      if (this.isLogin) {
        let courseIdByApplyInfo = this.outlineInfo.courseId;
        let companyId = await this.getCompanyIdByIdOfApplyCourse(courseIdByApplyInfo);
        let userQuantityAfterLogin = await this.checkUserExistenceAfterLogin(this.email,companyId,courseIdByApplyInfo);
        if (userQuantityAfterLogin != 0) {
          this.$message({
            type: "warning",
            message: window.vm.$i18n.t("new.title244"),
            customClass: "custom-warning-message"
          });
          return;
        }
      }
      // Đi đến chi tiết bán khóa học
      // cartadd is here to get all things that click or chosen by user
      const checkUsername = obj => obj.courseId === item.courseId;
      if (this.cart.some(checkUsername) == false) {
        this.cartadd.courseId = item.courseId;
        this.cartadd.courseName = item.courseName;
        this.cartadd.coursePrice = item.coursePrice;
        this.cartadd.courseCover = item.courseCover;
        this.cartadd.timestudy = item.courseEstimatedStudyTime;
        this.cartadd.totalless = item.courseCurriculumTotal;
        this.cartadd.qty = 1;
        this.cartadd.coursePriceDiscount = item.coursePriceDiscount;
        this.cartadd.offSelf = item.offSelf;
        this.cartadd.listId = listId;
        this.cartadd.catalogId = item.catalogId;
        this.cartadd.courseEvaluate = this.dataDetails.courseEvaluate;
        this.cartadd.courseBankInfo = item.courseBankInfo;
        this.cart.push(this.cartadd);
        this.saveCats();
      }
      this.$router.push({
        path: "/home/subscribeSelfCourse",
        query: {
          outlineInfo: JSON.stringify(this.outlineInfo)
        }
      });
    },
    saveCats() {
      // for save in local storage set the below code
      let parsed = JSON.stringify(this.cart);
      localStorage.setItem("cart_" + this.$lang(), parsed);
      this.viewCart(); // by this function we can see all products are save in web },
    },
    // we put the below code in methods
    viewCart() {
      if (localStorage.getItem("cart_" + this.$lang())) {
        this.cart = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
        // totall price in shopping cart
        this.reduce = 0;
        for (let index = 0; index < this.cart.length; index++) {
          if (this.cart[index].coursePrice < 0) {
            continue;
          }
          if (this.cart[index].offSelf != 0 && this.cart[index].coursePrice > 0) {
            this.reduce += this.cart[index].coursePrice - this.cart[index].coursePriceDiscount;
          } else {
            this.reduce += this.cart[index].coursePrice;
          }
        }
      }
    },
    // Curency position
    checkCurren() {
      if (this.$lang()) {
        if (this.$lang() == 3 || this.$lang() == 1) {
          this.beforCurren = true;
        } else {
          this.afterCurren = true;
        }
      }
    },
    /// Back page
    back() {
      if (this.outlineInfo.type == 1) {
        this.$router.push({
          path: "/home/index"
        });
      } else {
        this.$router.push({
          path: "/home/index"
        });
      }
    },
    /// load page
    async loadPageClick(params) {
      this.outlineInfo = params;
      this.init();
      this.loadPage = false;
      this.$nextTick(() => {
        this.loadPage = true;
      });
    },

    checkUserExistenceAfterLogin(email, companyId, courseId) {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/checkUserExistenceAfterLogin", {
            email : email,
            companyId: companyId,
            courseId: courseId
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },

    getCompanyIdByIdOfApplyCourse(id) {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getCompanyIdByIdOfApplyCourse", {
            courseId: id
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-content.mb {
  padding: 10px !important;
}
.modal-content.mb .top-close {
  height: 40px;
}
.modal-content.mb .cart-content {
  max-height: calc(100vh - 300px) !important;
  min-height: 400px;
  height: auto !important;
}
.container {
  width: 100%;
}
.flex-container {
  display: flex;
}
.flex-teacher {
  background: linear-gradient(57deg, #543ab7, #00acc1) !important;
}
.related-course .content {
  padding: 10px 20px;
}
.flex-container > .media-teacher {
  padding: 20px;
  width: 25%;
  background-color: rgba(0, 0, 0, 0.6);
}
.flex-container > .media-teacher .box-media img {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  display: block;
  margin: 0px auto;
}
.flex-container > .media-teacher .valuate-teacher {
  text-align: center;
}
.flex-container > .media-teacher .valuate-teacher .number-stars {
  font-size: 30px;
  font-weight: 700;
  color: #ffc700;
}
.flex-container .media-teacher .detail_course {
  color: #ffff;
}
.flex-container .media-teacher .box-text {
  text-align: center;
}
.flex-container .media-teacher .box-text .name-teacher {
  font-size: 18px;
  padding: 10px;
  color: #ffff;
}
.flex-container .media-teacher .box-text .icon-student {
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  line-height: 20px;
}
.flex-container .media-teacher .box-text .number-student {
  display: inline-block;
  color: #ffff;
  vertical-align: middle;
  font-size: 20px;
  padding-left: 5px;
}
.flex-container > .detail_course {
  padding: 20px;
  width: 75%;
  background-color: rgba(0, 0, 0, 0.6);
}
.flex-container .detail_course h3 {
  color: #ffff;
  font-size: 20px;
  padding: 5px;
  word-break: break-word;
}
.flex-container .detail_course h4 {
  color: #fff;
  font-size: 18px;
}
.flex-container .detail_course p {
  color: #ffff;
  font-size: 16px;
  line-height: 30px;
  padding: 5px;
  word-break: break-word;
}
.flex-container > .media-course {
  margin: 10px;
  padding: 20px;
  width: 50%;
}
.flex-container .media-course .box-media-course {
  position: relative;
  border: 1px solid rgb(226, 223, 223);
}
.flex-container .media-course .flash-sale {
  position: absolute;
  top: 10px;
  right: 20px;
}
.flex-container .media-course .flash-sale span {
  font-size: 30px;
  color: #cb0d0d;
  font-weight: 600;
  background: #e4e7ed;
  padding: 5px;
  border-radius: 5px;
}
.flex-container .media-course .box-media-course img {
  width: auto;
  height: 400px;
  margin: 0px auto;
  max-width: 100%;
}
.flex-container .detail_info-course {
  margin: 10px;
  padding: 20px;
  width: 50%;
}
.flex-container .detail_info-course {
  line-height: 40px;
}
.flex-container .detail_info-course .price h3 {
  font-size: 24px;
  font-weight: 600;
}
.flex-container .detail_info-course .price .cost {
  font-size: 30px;
  font-weight: 600;
  color: rgb(250, 18, 18);
}
.flex-container .detail_info-course .info p {
  font-size: 20px;
  font-weight: 500;
}
.detail_info-course .box-info span #cart {
  padding: 10px 15px;
  background-color: #000099;
  border-radius: 10px;
  text-decoration: none;
  color: #ffff;
  font-size: 20px;
  margin: 10px 10px 10px 0px;
  font-weight: 600;
  border: none;
  /* width: 250px; */
}
.detail_info-course .box-info span #sub {
  padding: 10px 15px;
  background-color: #ff3300;
  border-radius: 10px;
  text-decoration: none;
  color: #ffff;
  font-size: 20px;
  margin: 10px 10px 10px 0px;
  font-weight: 600;
  border: none;
  /* width: 250px; */
}
.content-course .content {
  padding: 10px 30px;
  font-size: 16px;
  line-height: 20px;
}
.header-tab h3 {
  background-color: #dddddd;
  padding: 10px;
  font-weight: 400;
  margin-bottom: 10px;
  font-size: 16px;
}
.header-tab span {
  float: right;
  cursor: pointer;
}
.header-tab p {
  margin: 0px;
}
.header-tab {
  cursor: pointer;
}
.catalog-course .content {
  padding: 10px 30px;
  font-size: 16px;
}
.lesson_content {
  width: 100%;
}
.lesson_content tr td {
  padding: 10px 50px;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 10px;
  position: relative;
}
.modal-error {
  width: 40% !important;
}
.messa-error {
  text-align: center;
  font-size: 16px;
  padding: 20px;
}
.button-error-continute {
  display: block;
  margin: 20px auto;
  background-color: #0071c5;
  border-radius: 10px;
  border: none;
  padding: 10px 20px;
  color: #fff;
}
/* The Close Button */
.close {
  color: #fff;
  float: right;
  font-size: 15px;
  font-weight: bold;
  border: 1px solid;
  /* border-color: gray; */
  border-radius: 7px;
  padding: 5px;
  background-color: #25368c;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
}

/* .close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
} */
.modal-content .item-image img {
  width: 100px;
}
.modal-content .item-close {
  font-size: 30px !important;
  cursor: pointer;
  color: #cb0d0d;
}
.modal-content .item-total p {
  font-size: 18px;
  padding: 10px 0px;
  border-top: 1px solid #0071c5;
  text-align: right;
}
.modal-content .item-total span {
  color: #cb0d0d;
}
.modal-content .cart-content .submit {
  padding: 10px 20px;
  background: #0071c5;
  border: none;
  color: #ffff;
  font-size: 20px;
  border-radius: 5px;
  display: block;
  margin: 0px auto;
  cursor: pointer;
}
.modal-content .cart-content .empty-cart {
  display: block;
  margin: 10px auto;
}
.shopping-cart .button-icon {
  position: fixed;
  right: 25px;
  bottom: 10px;
  z-index: 10;
}
.shopping-cart .button-icon img {
  width: 60px;
  cursor: pointer;
}
.shopping-cart .button-icon .total-item-cart {
  background-color: #ffff;
  border: 1px solid #000;
  padding: 5px;
  border-radius: 20px;
  position: absolute;
  right: 40px;
  top: 0px;
  z-index: 1000;
}
.modal-content .cart-content .cart-table td {
  font-size: 16px;
}
.modal-content .cart-content .cart-table td .item-price-cart {
  color: #cb0d0d;
}
/* Price */
del {
  color: blue;
  text-decoration: none;
  position: relative;
  font-size: 25px;
  font-weight: 700;
}
del ::before {
  content: " ";
  display: block;
  width: 100%;
  border-top: 2px solid #cb0d0d;
  height: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: rotate(-7deg);
}
.free-course {
  color: #cb0d0d;
  font-size: 25px;
  text-decoration: none;
  padding: 10px 0px;
  font-weight: 700;
}
ins {
  color: #cb0d0d;
  font-size: 25px;
  text-decoration: none;
  padding: 1em 1em 1em 0.5em;
  font-weight: 700;
}
h4 {
  color: red;
}
@media only screen and (max-width: 1100px) {
  .flex-container > .media-teacher {
    width: 30%;
  }
  /* Price */
  del {
    font-size: 20px;
  }
  ins {
    font-size: 25px;
  }
  .modal-content .cart-content .cart-table td {
    font-size: 16px;
    display: block;
  }
  .modal-content .cart-content .cart-table .item-close {
    width: 10%;
    position: relative;
    top: -85px;
    left: 90%;
  }
  .flex-container .media-course .box-media-course img {
    height: auto;
    width: 100%;
  }
}
@media only screen and (max-width: 700px) {
}
@media only screen and (max-width: 600px) {
  .flex-container {
    display: flex;
    flex-direction: column;
  }
  .flex-container > .media-teacher {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 20px;
    width: 100%;
  }
  .flex-container > .detail_course {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 20px;
    width: 100%;
  }
  .flex-container > .media-course {
    margin: 0px;
    padding: 0px;
    width: 100%;
  }
  .flex-container .detail_info-course {
    margin: 0px;
    padding: 10px;
    width: 100%;
  }
  .flex-container .detail_course p {
    font-size: 14px;
  }
  .detail_info-course .box-info span #cart {
    width: 80%;
    display: block;
    margin: 10px auto;
  }
  .detail_info-course .box-info span #sub {
    width: 80%;
    display: block;
    margin: 0px auto;
    margin: 10px auto;
  }
  /* Modal Content */
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 90% !important;
  }
  .modal-content .cart-content .cart-table td {
    display: block;
    font-size: 16px;
  }
  .lesson_content tr td {
    padding: 10px;
    font-size: 14px;
  }
  /* Price */
  del {
    font-size: 20px;
  }
  ins {
    font-size: 25px;
  }
  .shopping-cart .button-icon {
    position: fixed;
    right: 10px;
    bottom: 60px;
    z-index: 10;
  }
  .cart-content {
    height: 450px;
    overflow-y: scroll;
  }
}
.Stars {
  --star-size: 30px;
  --star-color: #fff;
  --star-background: #ffc700;
  --percent: calc(var(--rating) / 5 * 100%);
  display: inline-block;
  font-size: 30px;
  font-family: Times;
  line-height: 1;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (max-width: 1112px) {
  #explore .title {
    padding-left: 55px;
  }
}
.primarylists .titles .title {
  padding: 0 0px 0 10px;
}
.detail_info-course .box-info span #cancel_details {
  padding: 10px 15px;
  background-color: #9f9f9f;
  border-radius: 10px;
  text-decoration: none;
  color: #ffff;
  font-size: 20px;
  margin: 10px 10px 10px 0px;
  font-weight: 600;
  border: none;
  /* width: 250px; */
}
.cart_moblie {
  width: unset !important;
}
.image_youtube_moblie {
  height: 250px;
}
</style>



// WEBPACK FOOTER //
// src/views/defineSelfCourse/detailsSelfCourse.vue